import { Box, FormLabel, Switch } from '@chakra-ui/react'
import { organizationListContext } from 'brokertslib/src/context/OrganizationListContext'
import { OrganizationUnitType } from 'brokertslib/src/enums'
import { useContext } from 'react'

import { SwitchControl } from '../../components/SwitchControl'
import { SearchField } from '../shared/SearchField'

export const OrganizationListFilter = ({
  hideSearch,
  hideShowAll,
}: {
  hideSearch?: boolean
  hideShowAll?: boolean
}) => {
  const { filter, updateFilter, setCurrentPage } = useContext(
    organizationListContext,
  )

  return (
    <Box sx={{ display: 'flex', gap: 4, w: 'full' }}>
      {!hideSearch && (
        <SearchField
          onSearch={(search) => updateFilter({ ...filter, name: search })}
        />
      )}

      <SwitchControl sx={{ flexGrow: 1, justifyContent: 'right' }} mr={2}>
        <Switch
          size="md"
          id="showInactive"
          isChecked={filter.showInvalid}
          onChange={() => {
            updateFilter({ ...filter, showInvalid: !filter.showInvalid })
            setCurrentPage(1)
          }}
        />
        <FormLabel htmlFor="showInactive" variant="switch">
          Zobrazit i neaktivní
        </FormLabel>
      </SwitchControl>

      {!hideShowAll && (
        <SwitchControl mr={2}>
          <Switch
            size="md"
            id="showAll"
            isChecked={filter?.types?.at(0) !== OrganizationUnitType.Partner}
            onChange={(e) => {
              updateFilter({
                ...filter,
                types:
                  filter?.types?.at(0) !== OrganizationUnitType.Partner
                    ? [OrganizationUnitType.Partner]
                    : undefined,
              })
              setCurrentPage(1)
            }}
          />
          <FormLabel htmlFor="showAll" variant="switch">
            Zobrazit všechny organizace
          </FormLabel>
        </SwitchControl>
      )}
    </Box>
  )
}
